import { LucideProps } from 'lucide-react';
import { createLucideCompatIcon } from './createLucideCompatIcon';

/** Lucide v0 brand mark (removed in lucide-react v1). */
export const Facebook = createLucideCompatIcon(
  'facebook',
  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />,
);

/** Lucide v0 brand mark (removed in lucide-react v1). */
export const Github = createLucideCompatIcon(
  'github',
  <>
    <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4" />
    <path d="M9 18c-4.51 2-5-2-7-2" />
  </>,
);

/** Lucide v0 brand mark (removed in lucide-react v1). */
export const Gitlab = createLucideCompatIcon(
  'gitlab',
  <path d="m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z" />,
);

/** Lucide v0 brand mark (removed in lucide-react v1). */
export const Instagram = createLucideCompatIcon(
  'instagram',
  <>
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </>,
);

/** Lucide v0 brand mark (removed in lucide-react v1). */
export const Linkedin = createLucideCompatIcon(
  'linkedin',
  <>
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect width="4" height="12" x="2" y="9" />
    <circle cx="4" cy="4" r="2" />
  </>,
);

/** Lucide v0 brand mark (removed in lucide-react v1). */
export const Slack = createLucideCompatIcon(
  'slack',
  <>
    <rect width="3" height="8" x="13" y="2" rx="1.5" />
    <path d="M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5" />
    <rect width="3" height="8" x="8" y="14" rx="1.5" />
    <path d="M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5" />
    <rect width="8" height="3" x="14" y="13" rx="1.5" />
    <path d="M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5" />
    <rect width="8" height="3" x="2" y="8" rx="1.5" />
    <path d="M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5" />
  </>,
);

/** Lucide v0 brand mark (removed in lucide-react v1). */
export const Twitch = createLucideCompatIcon('twitch', <path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7" />);

/** Lucide v0 brand mark (removed in lucide-react v1). */
export const Youtube = createLucideCompatIcon(
  'youtube',
  <>
    <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" />
    <path d="m10 15 5-3-5-3z" />
  </>,
);

export const XTwitter = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={'lucide-x-twitter ' + className}
    {...props}
  >
    <g clipPath="url(#clip0_18345_202114)">
      <path
        opacity="0.8"
        d="M14.2833 10.1616L23.2178 -0.000732422H21.1006L13.3427 8.8231L7.14656 -0.000732422H0L9.36984 13.3425L0 23.9993H2.11732L10.3098 14.681L16.8534 23.9993H24L14.2827 10.1616H14.2833ZM11.3833 13.46L10.4339 12.1313L2.88022 1.55888H6.1323L12.2282 10.0912L13.1776 11.4199L21.1016 22.5106H17.8495L11.3833 13.4605V13.46Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_18345_202114">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Github2 = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M15 22V18C15.1392 16.7473 14.78 15.4901 14 14.5C17 14.5 20 12.5 20 9C20.08 7.75 19.73 6.52 19 5.5C19.28 4.35 19.28 3.15 19 2C19 2 18 2 16 3.5C13.36 3 10.64 3 8.00004 3.5C6.00004 2 5.00004 2 5.00004 2C4.70004 3.15 4.70004 4.35 5.00004 5.5C4.27191 6.51588 3.91851 7.75279 4.00004 9C4.00004 12.5 7.00004 14.5 10 14.5C9.61004 14.99 9.32004 15.55 9.15004 16.15C8.98004 16.75 8.93004 17.38 9.00004 18M9.00004 18V22M9.00004 18C4.49004 20 4 16 2 16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Telegram = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={'lucide-telegram ' + className}
    {...props}
  >
    <path
      d="M21.5 2.5L2 11l7.5 3L19 4.5l-6 11.5 3 6.5 5.5-20z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UsersRound2 = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M5.00016 17.5C5.00016 15.7319 5.70254 14.0362 6.95278 12.786C8.20303 11.5357 9.89872 10.8333 11.6668 10.8333M11.6668 10.8333C13.4349 10.8333 15.1306 11.5357 16.3809 12.786C17.6311 14.0362 18.3335 15.7319 18.3335 17.5M11.6668 10.8333C9.36564 10.8333 7.50016 8.96785 7.50016 6.66667C7.50016 4.36548 9.36564 2.5 11.6668 2.5C13.968 2.5 15.8335 4.36548 15.8335 6.66667C15.8335 8.96785 13.968 10.8333 11.6668 10.8333ZM1.66679 16.6666C1.66679 13.8583 3.33346 11.25 5.00012 9.99996C4.45227 9.58893 4.01419 9.0492 3.72465 8.42852C3.43511 7.80784 3.30303 7.12535 3.34011 6.44146C3.37719 5.75757 3.58227 5.09336 3.93723 4.50763C4.29218 3.92189 4.78605 3.43268 5.37512 3.08329"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LineHorizontal = ({ size = 12, ...props }: Omit<LucideProps, 'className'>) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fill-secondary"
    {...props}
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M12 12V11C5.92487 11 1 6.07513 1 0H0C0 6.62742 5.37258 12 12 12Z" />
  </svg>
);

export const RoundedCorner = ({ size = 12, ...props }: Omit<LucideProps, 'className'>) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="block size-full fill-secondary"
    preserveAspectRatio="none"
    {...props}
  >
    <path d="M1 0C1 6.07513 5.92487 11 12 11V12C5.37258 12 0 6.62742 0 0H1Z" />
  </svg>
);

export const Synonym = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M127.394 75.7495H99.9979L107.982 44.26L73.6099 75.5811V94.9463L127.394 95.0305V75.7495ZM93.0227 155.736L127.394 124.415V104.966H73.6099V124.247H100.922L93.0227 155.736Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.525 0.563843C165.505 6.37341 205.246 55.6284 199.436 110.525C193.627 165.505 144.372 205.246 89.4754 199.436C34.4951 193.627 -5.24572 144.372 0.563843 89.4754C6.37341 34.4951 55.6284 -5.24572 110.525 0.563843ZM108.335 21.4446C65.1426 16.8138 25.9912 48.4717 21.4446 91.6645C16.8138 134.857 48.4717 174.009 91.6645 178.555C134.857 183.186 174.009 151.528 178.555 108.335C183.186 65.1426 151.528 25.9912 108.335 21.4446Z"
      fill="#FF6600"
    />
  </svg>
);
export const Blocktank = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M131.669 113.82C128.529 114.86 124.829 115.64 120.769 115.64C113.209 115.64 104.449 112.94 95.7495 104.24C88.4095 96.9 80.6695 94.7 72.1095 97.56C65.5295 99.76 60.9695 104.18 60.9295 104.24L56.6895 108.48V125L99.9895 150L143.289 125V107.74C140.509 109.76 136.509 112.2 131.649 113.82H131.669Z"
      fill="#FFAE00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.329 86.18C77.349 83.18 90.889 82.4 104.249 95.76C111.589 103.1 119.329 105.3 127.889 102.44C134.469 100.24 139.029 95.82 139.069 95.76L143.309 91.52V75L100.009 50L56.709 75V92.24C59.489 90.22 63.489 87.8 68.329 86.18Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.525 0.564909C55.6299 -5.24509 6.37491 34.4949 0.564909 89.4749C-5.24509 144.37 34.4949 193.625 89.4749 199.435C144.37 205.245 193.625 165.505 199.435 110.525C205.245 55.6299 165.505 6.37491 110.525 0.564909ZM178.555 108.335C174.01 151.53 134.855 183.185 91.6649 178.555C48.4699 174.01 16.8149 134.855 21.4449 91.6649C25.9899 48.4699 65.1449 16.8149 108.335 21.4449C151.53 25.9899 183.185 65.1449 178.555 108.335Z"
      fill="#FFAE00"
    />
  </svg>
);

/** Google "G" brand mark (multi-colour, not themeable). Used by "Continue with Google" (Pubky Passport). */
export const Google = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M7.99988 6.54543V9.64362H12.3053C12.1163 10.64 11.5489 11.4836 10.698 12.0509L13.2944 14.0655C14.8071 12.6692 15.6798 10.6182 15.6798 8.18187C15.6798 7.61461 15.6289 7.06911 15.5344 6.54552L7.99988 6.54543Z"
      fill="#4285F4"
    />
    <path
      d="M3.51645 9.52268L2.93088 9.97093L0.858114 11.5854C2.17447 14.1963 4.87246 16 7.9997 16C10.1596 16 11.9705 15.2873 13.2942 14.0655L10.6979 12.0509C9.98512 12.5309 9.07602 12.8219 7.9997 12.8219C5.91972 12.8219 4.15249 11.4182 3.51972 9.5273L3.51645 9.52268Z"
      fill="#34A853"
    />
    <path
      d="M0.858119 4.41455C0.312695 5.49086 0 6.70543 0 7.99995C0 9.29447 0.312695 10.509 0.858119 11.5854C0.858119 11.5926 3.51998 9.5199 3.51998 9.5199C3.35998 9.03991 3.26541 8.53085 3.26541 7.99987C3.26541 7.46889 3.35998 6.95983 3.51998 6.47983L0.858119 4.41455Z"
      fill="#FBBC05"
    />
    <path
      d="M7.99987 3.18545C9.17807 3.18545 10.2253 3.59271 11.0617 4.37818L13.3526 2.0873C11.9635 0.792777 10.1599 0 7.99987 0C4.87262 0 2.17447 1.79636 0.858114 4.41455L3.5199 6.48001C4.15259 4.58908 5.91988 3.18545 7.99987 3.18545Z"
      fill="#EA4335"
    />
  </svg>
);

export const Bitkit = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 200 184"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M141.943 112.158C141.943 151.315 110.2 183.058 71.0431 183.058C31.8861 183.058 0.143066 151.315 0.143066 112.158C0.143066 73.0008 31.8861 41.2578 71.0431 41.2578C110.2 41.2578 141.943 73.0008 141.943 112.158ZM71.0431 165.858C100.701 165.858 124.743 141.816 124.743 112.158C124.743 82.5001 100.701 58.4578 71.0431 58.4578C41.3854 58.4578 17.3431 82.5001 17.3431 112.158C17.3431 141.816 41.3854 165.858 71.0431 165.858Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M63.6001 72.0692L83.0407 0H151.318C176.762 0 199.8 19.3956 199.8 45.728C199.8 55.4895 197.999 65.9339 192.333 74.9633C191.697 75.9776 191.022 76.9563 190.311 77.8989C191.091 78.9987 191.822 80.1473 192.503 81.3453C197.969 90.9652 199.108 101.909 198.072 112.454C196.917 124.199 192.165 135.604 183.092 144.125C173.907 152.752 161.593 157.2 147.693 157.2H108.958L115.448 135.581C116.685 131.458 117.351 127.098 117.351 122.568C117.351 101.062 102.03 82.1468 79.9841 76.3657L63.6001 72.0692ZM177.468 88.9824C176.902 88.0539 176.275 87.1678 175.587 86.3252C172.369 82.3872 167.805 79.4017 161.776 77.4957L161.773 77.4947C161.719 77.4775 161.664 77.4605 161.61 77.4435C161.596 77.4392 161.582 77.435 161.569 77.4308C161.56 77.4281 161.551 77.4254 161.543 77.4227C161.471 77.4161 161.416 77.3565 161.416 77.2851C161.416 77.2481 161.431 77.2143 161.455 77.1893C161.477 77.1662 161.508 77.1507 161.543 77.1475C161.551 77.1456 161.56 77.1436 161.569 77.1416C161.591 77.1367 161.613 77.1317 161.635 77.1267C167.915 75.6983 172.617 72.8357 175.984 68.8796C176.654 68.0925 177.271 67.2621 177.837 66.391C181.41 60.8951 182.956 53.7827 182.956 45.728C182.956 29.9495 168.791 16.8007 151.318 16.8007H95.9515L84.2669 60.1172C84.5265 60.1853 84.7855 60.2548 85.0439 60.3257C114.002 66.9798 134.195 90.757 134.195 122.568C134.195 122.912 134.192 123.256 134.186 123.599C134.091 129.417 133.19 135.05 131.584 140.399H147.693C148.135 140.399 148.572 140.393 149.005 140.381C168.62 139.843 179.696 127.217 181.308 110.815C182.164 102.109 180.976 94.7333 177.468 88.9824Z"
      fill="black"
    />
    <path
      d="M175.587 86.3259C176.275 87.1684 176.902 88.0546 177.468 88.9831C180.976 94.734 182.164 102.11 181.309 110.815C179.696 127.218 168.62 139.844 149.005 140.382C148.572 140.394 148.135 140.4 147.693 140.4H131.584C133.19 135.05 134.091 129.418 134.186 123.599C134.192 123.256 134.195 122.913 134.195 122.569C134.195 90.7577 114.002 66.9804 85.0439 60.3264C84.7856 60.2554 84.5266 60.1859 84.267 60.1178L95.9516 16.8013H151.318C168.791 16.8013 182.956 29.9501 182.956 45.7286C182.956 53.7833 181.41 60.8958 177.838 66.3917C177.271 67.2627 176.654 68.0931 175.984 68.8802C172.617 72.8363 167.915 75.6989 161.635 77.1273L161.596 77.1362L161.569 77.1423L161.543 77.1481C161.508 77.1513 161.477 77.1668 161.455 77.19C161.431 77.2149 161.416 77.2488 161.416 77.2857C161.416 77.3571 161.471 77.4167 161.543 77.4233L161.569 77.4314L161.61 77.4441C161.664 77.4611 161.719 77.4782 161.773 77.4953L161.776 77.4963C167.805 79.4023 172.369 82.3878 175.587 86.3259Z"
      fill="white"
    />
    <path
      d="M124.743 112.158C124.743 141.815 100.7 165.858 71.0428 165.858C41.3851 165.858 17.3428 141.815 17.3428 112.158C17.3428 82.5001 41.3851 58.4578 71.0428 58.4578C100.7 58.4578 124.743 82.5001 124.743 112.158Z"
      fill="#FF4400"
    />
  </svg>
);

export const BTCIcon = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0.004 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M63.04 39.741c-4.274 17.143-21.638 27.575-38.783 23.301C7.12 58.768-3.313 41.404.962 24.262 5.234 7.117 22.597-3.317 39.737.957c17.144 4.274 27.576 21.64 23.302 38.784z"
      fill="#f7931a"
    />
    <path
      d="M46.11 27.441c.636-4.258-2.606-6.547-7.039-8.074l1.438-5.768-3.512-.875-1.4 5.616c-.922-.23-1.87-.447-2.812-.662l1.41-5.653-3.509-.875-1.439 5.766c-.764-.174-1.514-.346-2.242-.527l.004-.018-4.842-1.209-.934 3.75s2.605.597 2.55.634c1.422.355 1.68 1.296 1.636 2.042l-1.638 6.571c.098.025.225.061.365.117l-.37-.092-2.297 9.205c-.174.432-.615 1.08-1.609.834.035.051-2.552-.637-2.552-.637l-1.743 4.02 4.57 1.139c.85.213 1.683.436 2.502.646l-1.453 5.835 3.507.875 1.44-5.772c.957.26 1.887.5 2.797.726L27.504 50.8l3.511.875 1.453-5.823c5.987 1.133 10.49.676 12.383-4.738 1.527-4.36-.075-6.875-3.225-8.516 2.294-.531 4.022-2.04 4.483-5.157zM38.087 38.69c-1.086 4.36-8.426 2.004-10.807 1.412l1.928-7.729c2.38.594 10.011 1.77 8.88 6.317zm1.085-11.312c-.99 3.966-7.1 1.951-9.083 1.457l1.748-7.01c1.983.494 8.367 1.416 7.335 5.553z"
      fill="#ffffff"
    />
  </svg>
);

export const Tether = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2000 2000"
    width={size}
    height={size}
    className={className}
    {...props}
  >
    <path
      d="M1000 0c552.26 0 1000 447.74 1000 1000s-447.76 1000-1000 1000S0 1552.38 0 1000 447.68 0 1000 0"
      fill="#53ae94"
    />
    <path
      d="M1123.42 866.76V718h340.18V491.34H537.28V718H877.5v148.64C601 879.34 393.1 934.1 393.1 999.7s208 120.36 484.4 133.14v476.5h246V1132.8c276-12.74 483.48-67.46 483.48-133s-207.48-120.26-483.48-133m0 225.64v-.12c-6.94.44-42.6 2.58-122 2.58-63.48 0-108.14-1.8-123.88-2.62v.2C633.34 1081.66 451 1039.12 451 988.22S633.36 894.84 877.62 884v166.1c16 1.1 61.76 3.8 124.92 3.8 75.86 0 114-3.16 121-3.8V884c243.8 10.86 425.72 53.44 425.72 104.16s-182 93.32-425.72 104.18"
      fill="#fff"
    />
  </svg>
);

export const MarkdownMark = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 208 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m15 10c-2.7614 0-5 2.2386-5 5v98c0 2.761 2.2386 5 5 5h178c2.761 0 5-2.239 5-5v-98c0-2.7614-2.239-5-5-5zm-15 5c0-8.28427 6.71573-15 15-15h178c8.284 0 15 6.71573 15 15v98c0 8.284-6.716 15-15 15h-178c-8.28427 0-15-6.716-15-15z"
      fill="currentColor"
    />
    <path
      d="m30 98v-68h20l20 25 20-25h20v68h-20v-39l-20 25-20-25v39zm125 0-30-33h20v-35h20v35h20z"
      fill="currentColor"
    />
  </svg>
);

export const PubkyIcon = ({ className, size = 24, ...props }: LucideProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6133 0L8.04785 3.36154L4.74401 1.28202L3.83457 4.78379L0 3.97891L3.4879 9.67247C5.38937 8.00389 7.88184 6.99219 10.61 6.99137V6.99142H10.6167V6.99137C13.3448 6.9922 15.8373 8.00391 17.7387 9.67248L21.2266 3.97891L17.3921 4.78379L16.4826 1.28202L13.1788 3.36154L10.6167 0.00440823V0.00436164L10.616 0.00351212L10.6133 0ZM10.6133 9.66582C6.12357 9.66582 2.48365 13.3029 2.48365 17.7898C2.48365 19.7315 3.16595 21.5122 4.29976 22.9073L1.18964 32.4116H20.0371L16.9269 22.9073C18.0607 21.5122 18.743 19.7315 18.743 17.7898C18.743 13.3029 15.1031 9.66582 10.6133 9.66582ZM14.9142 17.7899C14.9142 15.4165 12.9888 13.4923 10.6134 13.4923H10.6133C8.23793 13.4923 6.31251 15.4165 6.31251 17.7899C6.31251 19.4347 7.23722 20.8641 8.59649 21.5866L8.73608 21.6608L6.47016 28.5853H14.7565L12.4906 21.6608L12.6302 21.5866C13.9895 20.8641 14.9142 19.4347 14.9142 17.7899Z"
      fill="#C8FF00"
    />
  </svg>
);
